






































import Vue from "vue";
import { Component } from "nuxt-property-decorator";
import { Project } from "~/types/project";
import { getLanguage } from "~/shared";
import { handleError } from "~/shared/errorHandler";
import BaseLoader from "~/components/core/BaseLoader.vue";
import FeedbackButton from "~/components/layout/FeedbackButton.vue";
import { Lang } from "~/types/locale";

const AWorld = process.client
  ? import("~/three/ShowcaseWorld").then((m) => m.World)
  : undefined;

@Component({
  name: "ThreeRendererContainerComponent",
  components: {
    BaseLoader,
    FeedbackButton,
  },
})
export default class ThreeRendererContainer extends Vue {
  world!: any;
  isInitialized = false;
  errorMessage: string | null = null;

  get project(): Project | null {
    return this.$store.getters["projects/activeProject"];
  }

  get isMobile() {
    return this.$store.getters.isMobile as boolean;
  }

  mounted() {
    if (process.client) {
      this.init();
    }
  }

  beforeDestroy() {
    this.world?.stop();
  }

  init() {
    this.$nextTick(async () => {
      const container = this.$refs.renderContainer as HTMLElement;
      const World = await AWorld;
      if (!this.project) {
        this.errorMessage =
          getLanguage(this.$i18n.locale) === Lang.DE
            ? "Das Projekt wurde nicht gefunden. Entweder ist es nicht öffentlich oder es existiert kein Projekt mit dieser Id."
            : "The project could not be found. Either the project is not public or there simply exists no project with this id.";
        return;
      }

      if (container && this.project && World) {
        this.world = new World();

        try {
          await this.world.init({
            container,
            project: this.project,
            $store: this.$store,
            isMobile: this.isMobile,
          });
        } catch (err) {
          handleError(
            err,
            getLanguage(this.$i18n.locale),
            this,
            {
              file: "ThreeRendererContainer",
              method: "World.init()",
            },
            true
          );
          this.$notify({
            type: "warning",
            message: this.$tc("pages.three_plan.error_create_webgl"),
          });
          return;
        }
        // start the animation loop
        try {
          this.world.start();
        } catch (err) {
          handleError(
            err,
            getLanguage(this.$i18n.locale),
            this,
            {
              file: "ThreeRendererContainer",
              method: "World.start()",
            },
            true
          );
          this.errorMessage = this.$tc("pages.three_plan.error_create_webgl");
          this.$notify({
            type: "warning",
            message: this.$tc("pages.three_plan.error_create_webgl"),
          });
        }
        this.$store.commit("three/setWorld", this.world);
        this.isInitialized = true;
      } else {
        this.init();
      }
    });
  }
}
